import { render } from "./BillsView.vue?vue&type=template&id=243e8d6e&scoped=true"
import script from "./BillsView.vue?vue&type=script&lang=js"
export * from "./BillsView.vue?vue&type=script&lang=js"

import "./BillsView.vue?vue&type=style&index=0&id=243e8d6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243e8d6e"]])

export default __exports__